import type { ElementType, ReactNode } from 'react';
import { cn } from '@/lib/utils';
import type { PluginGroup } from '@/plugins/types';

type PluginPageHeaderGroup = Exclude<PluginGroup, 'core'> | 'configuration';

const GROUP_META: Record<PluginPageHeaderGroup, { title: string; text: string; bg: string }> = {
  analysis: {
    title: 'Wissen & Analyse',
    text: 'text-primary',
    bg: 'bg-primary/10',
  },
  data: {
    title: 'Datenmanagement',
    text: 'text-amber-500',
    bg: 'bg-amber-500/10',
  },
  admin: {
    title: 'Administration',
    text: 'text-destructive',
    bg: 'bg-destructive/10',
  },
  configuration: {
    title: 'Konfiguration',
    text: 'text-slate-600 dark:text-slate-300',
    bg: 'bg-slate-500/10 dark:bg-slate-300/10',
  },
};

interface PluginPageHeaderProps {
  group: PluginPageHeaderGroup;
  title: string;
  icon: ElementType;
  actions?: ReactNode;
}

export function PluginPageHeader({ group, title, icon: Icon, actions }: PluginPageHeaderProps) {
  const meta = GROUP_META[group];

  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-start md:justify-between">
      <div>
        <p className={cn('text-[11px] font-semibold uppercase tracking-[0.18em]', meta.text)}>
          {meta.title}
        </p>
        <div className="mt-3 flex items-center gap-3">
          <div className={cn('flex h-8 w-8 items-center justify-center rounded-lg', meta.bg)}>
            <Icon className={cn('h-3.5 w-3.5', meta.text)} />
          </div>
          <h1 className="text-2xl font-bold tracking-tight text-foreground">
            {title}
          </h1>
        </div>
      </div>

      {actions ? <div className="self-start md:self-auto">{actions}</div> : null}
    </div>
  );
}
